import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["backgroundColor", "fluid", "includeGlobalStyles"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { PageContext } from './Page.context';
import { PageGlobalStyle, StyledPage } from './Page.styles';

/**
 * @subcomponents ['PageBreadcrumb', 'PageContent', 'PageTitle']
 * @since 8.15.0
 */
export var Page = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var backgroundColor = _ref.backgroundColor,
    fluid = _ref.fluid,
    includeGlobalStyles = _ref.includeGlobalStyles,
    rest = _objectWithoutProperties(_ref, _excluded);
  var context = {
    fluid: fluid
  };
  return /*#__PURE__*/React.createElement(PageContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(StyledPage, _extends({
    ref: forwardedRef,
    backgroundColor: backgroundColor
  }, rest)), includeGlobalStyles && /*#__PURE__*/React.createElement(PageGlobalStyle, null));
});
Page.displayName = 'Page';
Page.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A color token or `null`
   * to remove the default background color.
   */
  backgroundColor: PropTypes.string,
  /**
   * By default, page components will be bound by the `Page.maxWidth` token.
   * Setting this to true will remove the max width bound.
   *
   * Setting this on `Page` will set `fluid` for all child page components.
   */
  fluid: PropTypes.bool,
  /**
   * By default, we include global style to remove the default margins from the `<body>` element.
   * You can disable adding of this global style by setting this to `false`.
   */
  includeGlobalStyles: PropTypes.bool
} : {};
Page.defaultProps = {
  includeGlobalStyles: true
};